import React, { useState, useEffect } from "react";
import SearchBar from "../layout/SearchBar";
import ManageUserTable from "./ManageUserTable";
import { getAdminUsersData } from "../../actions/ManageUserAction";
import Pagination from "../layout/Pagination";
import Loading from "../layout/Loading";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

const ManageUserTableOverview = ({ searchTerm, setSearchTerm }) => {
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [localSearchTerm, setLocalSearchTerm] = useState(searchTerm || "");
  const navigate = useNavigate();

  const fetchUserData = async (search = "") => {
    try {
      setLoading(true);
      const userId = localStorage.getItem("adminId");
      const response = await getAdminUsersData({
        userId,
        searchTerm: search,
        page: currentPage,
        limit: itemsPerPage,
      });

      if (response.success) {
        setUsers(response.data);
        setTotalPages(response.totalPages || 1);
        setTotalCount(response.totalCount || 0);
        // setCurrentPage(response.currentPage || currentPage);
      } else {
        toast.error(response?.message || "Failed to fetch admin user data.");
        navigate("/manageUsers");
      }
    } catch (err) {
      toast.error("Error fetching admin users. Please try again.");
      navigate("/manageUsers");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData(searchTerm, currentPage, itemsPerPage);
  }, [currentPage, itemsPerPage]);

  const handleSearch = () => {
  setCurrentPage(1); // reset to first page
  fetchUserData(localSearchTerm, 1, itemsPerPage); // single API call
  setSearchTerm(localSearchTerm); // optional: keep global state updated
};
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
  };
  const refreshPage = () => {
    fetchUserData(searchTerm, currentPage, itemsPerPage);
  };
  return (
    <div>
      {loading ? (
        <>
          <Loading />
        </>
      ) : (
        <>
          {/* Desktop/tablet search bar only */}
          <div className="hidden md:flex justify-end items-center py-6 px-4 sm:px-6">
            <SearchBar
              searchTerm={localSearchTerm}
              onChange={(value) => setLocalSearchTerm(value)}
              onSearch={handleSearch}
              className="w-96"
            />
          </div>
          <div className="md:px-6">
            <ManageUserTable
              users={users}
              setUsers={setUsers}
              refreshData={refreshPage}
            />
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              totalCount={totalCount}
              onPageChange={handlePageChange}
              itemsPerPage={itemsPerPage}
              onItemsPerPageChange={handleItemsPerPageChange}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default ManageUserTableOverview;
